export default __webpack_public_path__ + "static/eric-3d029c988da38efe491d45f11584291c.jpg";